var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { action, observable } from "mobx";
// this class has ignore flag because action and observable implement interfaces
// and testing typescript interfaces is not possible with jest
// https://github.com/kulshekhar/ts-jest/issues/378
// i believe jest expects action.d.ts and observable.d.ts to be covered with tests as well as this file
// and that's why although this class is fully covered test coverage for branches without the flag is 33.3%
/* istanbul ignore next */
export class Retriever {
    constructor(messageBus, backgroundImg) {
        this.internalMessageBus = messageBus;
        this.liveMasterEvent = {};
        this.backgroundImg = backgroundImg;
    }
    activate() {
        this.internalMessageBus.on(InternalMessageBusChannels.legacy.eventView.event.update, this.updateData);
    }
    deactivate() {
        this.internalMessageBus.off(InternalMessageBusChannels.legacy.eventView.event.update, this.updateData);
    }
    updateData(message) {
        this.liveMasterEvent = message.data[0];
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "liveMasterEvent", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateData", null);
//# sourceMappingURL=Retriever.js.map